import { useVenderSupportItems } from './useVenderSupportItems'

export const useVenderOrderService = ({ venderId }) => {
  const result = useVenderSupportItems({
    target: 'orderService',
    venderId,
  })
  if (result?.data) return { ...result, data: result.data }
  return result
}
